"use client";

type HeroLogoMarkProps = {
  className?: string;
  centered?: boolean;
};

/**
 * Static full wordmark fallback (INSIGHT + FEATURES) when WebGL is unavailable.
 */
export function HeroLogoMark({ className = "", centered = true }: HeroLogoMarkProps) {
  return (
    <div
      className={`flex h-full w-full items-center justify-center bg-black ${className}`}
      aria-hidden={centered}
    >
      <svg
        viewBox="0 0 1752 755"
        xmlns="http://www.w3.org/2000/svg"
        className="h-auto w-[min(92vw,52rem)] text-white"
        fill="currentColor"
        role={centered ? "img" : undefined}
        aria-label={centered ? undefined : "Insight Features logo"}
      >
        <g transform="translate(430,-151.1)">
          <path d="M -430,505.1 C -430,455.3 -430,405.5 -430,355.7 -409,355.7 -387,355.7 -366,355.7 -366,455.3 -366,554.8 -366,654.4 -387,654.4 -409,654.4 -430,654.4 -430,604.6 -430,554.9 -430,505.1 Z" />
          <path
            fillRule="evenodd"
            d="M -300,355.7 -219,356.3 -89.83,578.3 -90.53,355.7 -34.54,355.7 -34.54,654.3 -116,654.3 -246,434.7 -245,654.3 -300,654.3 Z"
          />
          <path
            fillRule="evenodd"
            d="M 390 151.1 L 390 340 L 116.4 498 L 38 452.8 L 38 354.4 L 390 151.1 Z"
          />
          <path
            fillRule="evenodd"
            d="M 124.23 503.873 L 217.191 555.427 L 380.691 461.027 L 287.73 409.473 L 124.23 503.873 Z"
          />
          <path
            fillRule="evenodd"
            d="M -47.1 718.6 L -47.1 906.1 L 389.6 654.1 L 389.6 467.1 L -47.1 718.6 Z"
          />
          <path d="M 433.1,505.1 433.1,355.7 469.3,355.7 469.3,654.4 433.1,654.4 Z" />
          <path d="M 658,658.2 C 615.5,655.7 588,643.2 564.3,619.4 541.8,596.9 530.5,565.2 526.8,523.1 520.5,451.9 548,395.6 601.8,369.2 641.8,348.7 703,346.4 753,363.3 L 771.8,368.7 C 768,376.8 756.8,400.2 755.5,400.4 755.5,400.7 750.5,399.2 744.3,397.2 720.5,387.9 695.5,383.8 671.8,384.8 650.5,385.7 638,388.9 623,396.3 595.5,409.4 576.8,433.1 568,465.2 565.5,475.3 565.5,481.6 564.3,498.8 563,531.2 566.8,551.8 576.8,572.6 588,593.2 599.3,604.4 620.5,615.7 639.3,624.4 649.3,625.7 680.5,625.7 705.5,625.7 711.8,625.7 731.8,621.9 L 738,620.7 738,575.6 738,530.7 705.5,530.7 671.8,530.7 671.8,514.4 671.8,498.2 723,498.2 774.3,498.2 774.3,571.1 774.3,644.4 761.8,646.9 C 746.8,651.9 726.8,655.7 711.8,656.9 698,658.2 666.8,659.4 658,658.2 Z" />
          <path d="M 836.8,505.1 C 836.8,455.3 836.8,405.5 836.8,355.7 848.5,355.7 860.1,355.7 871.8,355.7 871.8,398.2 871.8,440.7 871.8,483.2 924,483.2 976,483.2 1028,483.2 1028,440.7 1028,398.2 1028,355.7 1040,355.7 1052,355.7 1063,355.7 1063,455.3 1063,554.8 1063,654.4 1052,654.4 1040,654.4 1028,654.4 1028,607.7 1028,561.1 1028,514.4 976,514.4 924,514.4 871.8,514.4 871.8,561.1 871.8,607.7 871.8,654.4 860.1,654.4 848.5,654.4 836.8,654.4 836.8,604.6 836.8,554.9 836.8,505.1 Z" />
          <path d="M 1192,521.3 C 1192,476.9 1192,432.6 1192,388.2 1161,388.2 1130,388.2 1098,388.2 1098,377.4 1098,366.5 1098,355.7 1173,355.7 1248,355.7 1322,355.7 1322,366.5 1322,377.4 1322,388.2 1291,388.2 1260,388.2 1228,388.2 1228,476.9 1228,565.7 1228,654.4 1216,654.4 1204,654.4 1192,654.4 1192,610 1192,565.7 1192,521.3 Z" />
          <text
            x="598"
            y="820"
            fontFamily="Open Sans, sans-serif"
            fontWeight="300"
            fontSize="140"
          >
            FEATURES
          </text>
        </g>
      </svg>
    </div>
  );
}
